import { z } from "zod";

import i18n from "@/i18n";

export const loginSchema = z.object({
	email: z
		.string({ required_error: i18n.t("login.emailRequired") })
		.min(1, i18n.t("login.emailRequired"))
		.email(i18n.t("login.emailInvalid")),
	password: z
		.string({ required_error: i18n.t("login.passwordRequired") })
		.min(1, i18n.t("login.passwordRequired"))
		.max(128, i18n.t("login.passwordTooLong")),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
